import * as _ from 'lodash';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[decimalNumbers]',
    standalone: false
})
export class DecimalNumbersDirective {
    // Allow decimals with 2 digits after the separator (dot or comma)
    private dotOrCommaRegex = new RegExp(/^[0-9]+([\.,][0-9]{0,2})?$/);

    // Allow key codes for special events
    private specialKeys = ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];

    constructor(private el: ElementRef) {}

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        // Determine the input element (supports host input or nested input)
        const host = this.el.nativeElement as HTMLElement | HTMLInputElement;
        const isInput = 'value' in host;
        const inputEl = (
            isInput ? (host as HTMLInputElement) : (host as HTMLElement).querySelector('input')
        ) as HTMLInputElement | null;

        if (!inputEl) {
            return;
        }

        // Current value prior to applying this keystroke
        const current: string = inputEl.value ?? '';

        // If selection positions are not available, do not block typing
        const selectionStart = inputEl.selectionStart;
        const selectionEnd = inputEl.selectionEnd;
        if (selectionStart == null || selectionEnd == null) {
            return;
        }

        const valueBefore = current.substring(0, selectionStart);
        const valueAfter = current.substring(selectionEnd, current.length);
        const next: string = valueBefore.concat(event.key, valueAfter);

        const regex = this.dotOrCommaRegex;
        if (next && !String(next).match(regex)) {
            event.preventDefault();
        }
    }
}
